import { render, staticRenderFns } from "./upsell-groups.vue?vue&type=template&id=58f657a8"
import script from "./upsell-groups.vue?vue&type=script&lang=js"
export * from "./upsell-groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports